//获取微信openid
import axios from 'axios'
import { mySessionStorage } from '@/utils/storage.js'
function getOpenid() {
    //let openid=mySessionStorage.getItem("openid");
    let code = window.location.search.split('&')[0].split('=')[1];
    console.log("------"+code);
    let urlPath =this.$api.getOpenidUrl+'?code='+code;
    let that=this;
   mySessionStorage.setItem("openid",'');
    var p = new Promise(
      function (resolve, reject) {
        axios
          .get(urlPath)
          .then((res) => {
            mySessionStorage.setItem("openid",res.data.data.openid)
            console.log("---获取成功---"+res.data.data.openid);
            resolve(res);
          })
          .catch(function (err) {
            console.log("---获取失败---"+err);
            console.log(err);
            that.$toast("获取openid失败");
            reject(err)
          });
      }
    );
    return p;

}



export default getOpenid



// WEBPACK FOOTER //
// ./src/utils/wxUtils.js